import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { change_user_status, create_user, delete_user, get_user, update_user } from '../../utils/api-routes';

function* getUser() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_user}`);
        console.log("Get User Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_USER, payload: data?.results?.reverse() });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get User Saga Error ::: ", error)
    }
}

function* createUser(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_user}`, payload?.data);
        console.log("Create User Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "User Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create User',
            text: "Failed To Create User",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create User Saga Error ::: ", error?.response?.data)
    }
}

function* updateUser(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_user}`, payload?.data);
        console.log("Update User Saga Response ::: ", data)

        if (data?.success) {
            Swal.fire({
                icon: "success",
                title: "User Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_USER, payload: null })
        }

    } catch (error) {
        console.log("Update User Saga Error ::: ", error?.response?.data)
    }
}

function* deleteUser(action) {
    try {
        const { payload } = action;
        console.log("Delete User Payload ::: ", payload)

        const result = yield call(Swal.fire, {
            title: `Are You Sure To Delete?`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Swal Result ::: ", result)

        if (result.isConfirmed) {
            console.log("Calling delete API with payload:", payload)
            const { data } = yield call(axios.post, `${api_urls + delete_user}`, payload);
            console.log("Delete User API Response ::: ", data)
            if (data?.status) {
                yield call(Swal.fire, {
                    icon: "success",
                    title: "User Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_USER, payload: null })
            } else {
                yield call(Swal.fire, {
                    icon: "error",
                    title: "Delete Failed",
                    text: data?.error || "Could not delete user",
                    showConfirmButton: true,
                });
            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete User",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete User Saga Error ::: ", error?.response?.data)
    }
}

function* changeUserStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_user_status}`, payload);
            console.log("Change User Status Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_USER, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change User Status Saga Error ::: ", error?.response?.data)
    }
}

export default function* userSaga() {
    yield takeLeading(actionTypes?.GET_USER, getUser);
    yield takeLeading(actionTypes?.CREATE_USER, createUser);
    yield takeLeading(actionTypes?.UPDATE_USER, updateUser);
    yield takeLeading(actionTypes?.DELETE_USER, deleteUser);
    yield takeLeading(actionTypes?.CHANGE_USER_STATUS, changeUserStatus);
}
